import React, { useState } from "react";
import { Drawer } from "antd";
import { LuMenu } from "react-icons/lu";
import "./SideDrawer.css";
import { Link } from "react-router-dom";

const SideDrawer = () => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className="menu">
      <LuMenu className="menuBtn" onClick={showDrawer} />
      <Drawer onClose={onClose} open={open}>
        <ul>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>
            <Link to={"/privacyPolicy"}>Privacy Policy</Link>
          </li>
        </ul>
      </Drawer>
    </div>
  );
};
export default SideDrawer
